import React, { useState, useEffect, useCallback } from 'react';
import { fetchFiltrosSalvos, criarFiltroSalvo, removerFiltroSalvo } from '../../../api/filtros';
import './FiltrosSalvos.css';

// Componente reutilizável de filtros salvos (Fase 5A).
// Props:
//  - escopo: contexto do filtro (ex.: 'chamados')
//  - definicaoAtual: objeto com o estado atual dos filtros da tela
//  - onAplicar(definicao): aplica um filtro salvo na tela
function FiltrosSalvos({ escopo = 'chamados', definicaoAtual = {}, onAplicar }) {
  const [filtros, setFiltros] = useState([]);
  const [carregando, setCarregando] = useState(false);
  const [selecionado, setSelecionado] = useState('');
  const [salvando, setSalvando] = useState(false);
  const [mostrarForm, setMostrarForm] = useState(false);
  const [nome, setNome] = useState('');
  const [compartilhado, setCompartilhado] = useState(false);
  const [erro, setErro] = useState('');

  const recarregar = useCallback(async () => {
    setCarregando(true);
    const lista = await fetchFiltrosSalvos(escopo);
    setFiltros(lista);
    setCarregando(false);
  }, [escopo]);

  useEffect(() => { recarregar(); }, [recarregar]);

  const aplicar = (idStr) => {
    setSelecionado(idStr);
    const f = filtros.find((x) => String(x.id) === String(idStr));
    if (f && typeof onAplicar === 'function') onAplicar(f.definicao || {});
  };

  const salvar = async () => {
    setErro('');
    if (!nome.trim()) { setErro('Informe um nome.'); return; }
    setSalvando(true);
    try {
      await criarFiltroSalvo({ nome: nome.trim(), escopo, definicao: definicaoAtual, compartilhado });
      setNome('');
      setCompartilhado(false);
      setMostrarForm(false);
      await recarregar();
    } catch (e) {
      setErro(e?.response?.data?.error || 'Erro ao salvar filtro.');
    } finally {
      setSalvando(false);
    }
  };

  const excluir = async (id) => {
    try {
      await removerFiltroSalvo(id);
      if (String(selecionado) === String(id)) setSelecionado('');
      await recarregar();
    } catch (e) {
      setErro(e?.response?.data?.error || 'Erro ao remover filtro.');
    }
  };

  const filtroSel = filtros.find((x) => String(x.id) === String(selecionado));

  return (
    <div className="filtros-salvos">
      <div className="filtros-salvos-linha">
        <i className="fas fa-bookmark filtros-salvos-icone" />
        <select
          className="form-control form-control-sm filtros-salvos-select"
          value={selecionado}
          onChange={(e) => aplicar(e.target.value)}
          disabled={carregando}
        >
          <option value="">{carregando ? 'Carregando...' : 'Filtros salvos…'}</option>
          {filtros.map((f) => (
            <option key={f.id} value={f.id}>
              {f.nome}{f.compartilhado && !f.proprio ? ' (compartilhado)' : ''}
            </option>
          ))}
        </select>

        {filtroSel && filtroSel.proprio && (
          <button
            type="button"
            className="btn btn-outline-danger btn-sm"
            title="Excluir este filtro"
            onClick={() => excluir(filtroSel.id)}
          >
            <i className="fas fa-trash" />
          </button>
        )}

        <button
          type="button"
          className="btn btn-outline-primary btn-sm"
          onClick={() => { setMostrarForm((v) => !v); setErro(''); }}
        >
          <i className="fas fa-plus me-1" />Salvar atual
        </button>
      </div>

      {mostrarForm && (
        <div className="filtros-salvos-form">
          <input
            type="text"
            className="form-control form-control-sm"
            placeholder="Nome do filtro"
            value={nome}
            onChange={(e) => setNome(e.target.value)}
            maxLength={120}
            onKeyDown={(e) => { if (e.key === 'Enter') salvar(); }}
          />
          <label className="filtros-salvos-check">
            <input type="checkbox" checked={compartilhado} onChange={(e) => setCompartilhado(e.target.checked)} />
            <span>Compartilhar com a equipe</span>
          </label>
          <button type="button" className="btn btn-primary btn-sm" onClick={salvar} disabled={salvando}>
            {salvando ? 'Salvando...' : 'Salvar'}
          </button>
          <button type="button" className="btn btn-link btn-sm" onClick={() => { setMostrarForm(false); setErro(''); }}>
            Cancelar
          </button>
        </div>
      )}

      {erro && <div className="filtros-salvos-erro">{erro}</div>}
    </div>
  );
}

export default FiltrosSalvos;
